import React from 'react';
import { Fill, Left } from 'react-spaces';
import { Outlet } from 'react-router-dom';
import { useResponsive } from 'ahooks';

import { Sider, SiderTrigger } from 'src/components/coreUI';
import { useAppDispatch, useAppSelector } from 'src/store';
import drawer from 'src/store/ui/drawer';

const Split: React.FC = ({ children }) => {
  const layoutSplit = useAppSelector((state) => state.ui.app.layoutSplit);
  const screen = useResponsive();
  const dispatch = useAppDispatch();

  return (
    <Fill as="main">
      {/* table and mobile will be hide */}
      <Left size={!screen.lg ? '0%' : layoutSplit}>
        <aside className="layout layout_left">
          <Sider />
        </aside>
      </Left>
      <Fill scrollable>
        {!screen.lg && (
          <SiderTrigger
            onClick={() => dispatch(drawer.open({ name: 'menu_sider' }))}
          />
        )}
        <div
          className="layout layout_split"
          style={{ paddingLeft: !screen.lg ? 24 : 0 }}
        >
          {children || <Outlet />}
        </div>
      </Fill>
    </Fill>
  );
};

export default Split;
